import React, { Component } from "react";
import { Button, Card, Col, Form, Row, Spinner } from 'react-bootstrap';
import paginationFactory, { PaginationProvider, PaginationListStandalone, SizePerPageDropdownStandalone } from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { Search, CSVExport } from 'react-bootstrap-table2-toolkit';
import BootstrapTable from 'react-bootstrap-table-next';
import { Fetcher } from "../../Helpers/fetcher.js";
import { Redirect } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Cookies from 'js-cookie';

const { ExportCSVButton } = CSVExport;
const { SearchBar } = Search;

const defaultSorted = [{ dataField: 'id', order: 'desc' }];

const ACTION_BADGE = {
    LOGIN:        { cls: 'badge-success',   icon: 'fa-sign-in'   },
    LOGOUT:       { cls: 'badge-secondary', icon: 'fa-sign-out'  },
    SWITCH_LOGIN: { cls: 'badge-warning',   icon: 'fa-exchange'  },
};

const fmt = d => {
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${y}-${m}-${day}`;
};

export default class ActivityLogs extends Component {

    constructor(props) {
        super(props);
        const today = new Date();
        this.state = {
            logs: [],
            userList: [],
            startDate: today,
            endDate: today,
            filterUserId: '',
            isLoading: true,
            userType: '',
            sizePerPage: 10,
        };
    }

    componentDidMount() {
        const saved = Cookies.get('activityLogsSizePerPage');
        if (saved) this.setState({ sizePerPage: Number(saved) });
        this.getUserProfile();
    }

    getUserProfile = () => {
        const { apiPath, userId } = this.props.app;
        Fetcher.get(apiPath + '/api/obd/user/profile/' + userId)
            .then(res => {
                const userType = res.userType || '';
                this.setState({ userType }, () => {
                    this.fetchUsers();
                    this.fetchLogs();
                });
            })
            .catch(err => console.log('Error fetching profile', err));
    }

    fetchUsers = () => {
        const { apiPath, userId } = this.props.app;
        const { userType } = this.state;
        Fetcher.get(`${apiPath}/api/obd/activity/logs/users?userId=${userId}&userType=${userType}`)
            .then(res => {
                this.setState({ userList: Array.isArray(res) ? res : [] });
            })
            .catch(err => console.log('Error fetching users', err));
    }

    fetchLogs = () => {
        const { apiPath, userId } = this.props.app;
        const { userType, startDate, endDate, filterUserId } = this.state;

        let url = `${apiPath}/api/obd/activity/logs?userId=${userId}&userType=${userType}&startDate=${fmt(startDate)}&endDate=${fmt(endDate)}`;
        if (filterUserId) url += `&filterUserId=${filterUserId}`;

        this.setState({ isLoading: true, logs: [] });
        Fetcher.get(url)
            .then(res => {
                this.setState({ logs: Array.isArray(res) ? res : [], isLoading: false });
            })
            .catch(err => {
                console.log('Error fetching activity logs', err);
                this.setState({ isLoading: false });
            });
    }

    handleSearch = (e) => {
        e.preventDefault();
        this.fetchLogs();
    }

    handleReset = () => {
        const today = new Date();
        this.setState({ startDate: today, endDate: today, filterUserId: '' }, this.fetchLogs);
    }

    render() {
        const { logs, userList, startDate, endDate, filterUserId, isLoading, sizePerPage, userType } = this.state;
        const userId = this.props.app.userId;

        if (!userId) return <Redirect to="/login" />;

        const columns = [
            {
                dataField: 'id',
                text: '#',
                sort: true,
                headerStyle: { width: '70px' }
            },
            {
                dataField: 'action',
                text: 'Action',
                sort: true,
                headerStyle: { width: '140px' },
                formatter: (cell) => {
                    const cfg = ACTION_BADGE[cell] || { cls: 'badge-primary', icon: 'fa-circle' };
                    return (
                        <span className={`badge ${cfg.cls}`} style={{ fontSize: '12px', padding: '5px 10px' }}>
                            <i className={`fa ${cfg.icon} mr-1`}></i>{cell}
                        </span>
                    );
                }
            },
            { dataField: 'username',  text: 'Username',   sort: true },
            { dataField: 'userId',    text: 'User ID',    sort: true, headerStyle: { width: '100px' } },
            { dataField: 'requestIp', text: 'IP Address', sort: true, headerStyle: { width: '150px' } },
            { dataField: 'createdAt', text: 'Date & Time', sort: true, headerStyle: { width: '180px' } },
        ];

        const paginationOption = {
            custom: true,
            totalSize: logs.length,
            sizePerPage,
            sizePerPageList: [
                { text: '10',  value: 10  },
                { text: '25',  value: 25  },
                { text: '50',  value: 50  },
                { text: '100', value: 100 },
            ],
            onSizePerPageChange: (size) => {
                this.setState({ sizePerPage: size });
                Cookies.set('activityLogsSizePerPage', size);
            }
        };

        return (
            <div className="animated fadeIn">
                <Row>
                    <Col>
                        <Card>
                            <Card.Header style={{ background: '#fff', borderBottom: '2px solid #f0f0f0', padding: '14px 20px' }}>
                                <div className="d-flex align-items-center justify-content-between">
                                    <div>
                                        <i className="fa fa-clock-o mr-2" style={{ color: '#20a8d8' }}></i>
                                        <strong style={{ fontSize: '15px' }}>Activity Logs</strong>
                                        <span className="ml-2 badge badge-light" style={{ fontSize: '12px', fontWeight: 'normal' }}>
                                            {userType === 'superadmin' ? 'All Users' : 'Your Users'}
                                        </span>
                                    </div>
                                    {logs.length > 0 && (
                                        <span className="badge badge-info" style={{ fontSize: '12px' }}>
                                            {logs.length} records
                                        </span>
                                    )}
                                </div>
                            </Card.Header>
                            <Card.Body>

                                {/* Filter Section */}
                                <div style={{ background: '#f8f9fa', borderRadius: '6px', padding: '16px 20px', marginBottom: '20px', border: '1px solid #e9ecef' }}>
                                    <Form onSubmit={this.handleSearch}>
                                        <div className="d-flex flex-wrap align-items-flex-end" style={{ gap: '12px' }}>
                                            <div style={{ flex: '0 0 180px' }}>
                                                <div className="mb-1" style={{ fontSize: '13px', fontWeight: '600', color: '#495057' }}>
                                                    <i className="fa fa-calendar mr-1"></i> Start Date
                                                </div>
                                                <DatePicker
                                                    className="form-control form-control-sm"
                                                    selected={startDate}
                                                    onChange={date => this.setState({ startDate: date })}
                                                    dateFormat="yyyy-MM-dd"
                                                    maxDate={new Date()}
                                                />
                                            </div>
                                            <div style={{ flex: '0 0 180px' }}>
                                                <div className="mb-1" style={{ fontSize: '13px', fontWeight: '600', color: '#495057' }}>
                                                    <i className="fa fa-calendar-check-o mr-1"></i> End Date
                                                </div>
                                                <DatePicker
                                                    className="form-control form-control-sm"
                                                    selected={endDate}
                                                    onChange={date => this.setState({ endDate: date })}
                                                    dateFormat="yyyy-MM-dd"
                                                    minDate={startDate}
                                                    maxDate={new Date()}
                                                />
                                            </div>
                                            {userType !== 'user' && (
                                            <div style={{ flex: '1 1 200px' }}>
                                                <div className="mb-1" style={{ fontSize: '13px', fontWeight: '600', color: '#495057' }}>
                                                    <i className="fa fa-user mr-1"></i> User
                                                </div>
                                                <Form.Control
                                                    as="select"
                                                    size="sm"
                                                    value={filterUserId}
                                                    onChange={e => this.setState({ filterUserId: e.target.value })}
                                                >
                                                    <option value="">-- All Users --</option>
                                                    {userList.map(u => (
                                                        <option key={u.userId} value={u.userId}>
                                                            {u.username}
                                                        </option>
                                                    ))}
                                                </Form.Control>
                                            </div>
                                            )}
                                            <div className="d-flex" style={{ gap: '8px', paddingTop: '22px' }}>
                                                <Button
                                                    type="submit"
                                                    variant="primary"
                                                    size="sm"
                                                    disabled={isLoading}
                                                    style={{ minWidth: '80px', whiteSpace: 'nowrap' }}
                                                >
                                                    {isLoading
                                                        ? <><Spinner animation="border" size="sm" /><span className="ml-1">...</span></>
                                                        : <><i className="fa fa-search mr-1"></i>Search</>
                                                    }
                                                </Button>
                                                <Button
                                                    type="button"
                                                    variant="outline-secondary"
                                                    size="sm"
                                                    onClick={this.handleReset}
                                                    disabled={isLoading}
                                                    title="Reset filters"
                                                >
                                                    <i className="fa fa-refresh"></i>
                                                </Button>
                                            </div>
                                        </div>
                                    </Form>
                                </div>

                                {/* Table */}
                                <PaginationProvider pagination={paginationFactory(paginationOption)}>
                                    {({ paginationProps, paginationTableProps }) => (
                                        <ToolkitProvider
                                            keyField="id"
                                            data={logs}
                                            columns={columns}
                                            search
                                            exportCSV={{ fileName: `activity-logs-${fmt(new Date())}.csv` }}
                                        >
                                            {toolkitProps => (
                                                <>
                                                    <Row className="mb-3 align-items-center">
                                                        <Col md={6} xs={12}>
                                                            <SearchBar
                                                                {...toolkitProps.searchProps}
                                                                placeholder="Search by username, IP, action..."
                                                                style={{ fontSize: '13px' }}
                                                            />
                                                        </Col>
                                                        <Col md={6} xs={12} className="text-right">
                                                            <ExportCSVButton
                                                                {...toolkitProps.csvProps}
                                                                className="btn btn-outline-success btn-sm"
                                                            >
                                                                <i className="fa fa-download mr-1"></i> Export CSV
                                                            </ExportCSVButton>
                                                        </Col>
                                                    </Row>

                                                    <BootstrapTable
                                                        remote={false}
                                                        {...toolkitProps.baseProps}
                                                        {...paginationTableProps}
                                                        defaultSorted={defaultSorted}
                                                        noDataIndication={() => isLoading
                                                            ? <div className="fetching-data"><img alt="" src="/assets/loading.gif" /></div>
                                                            : <div className="text-center text-muted py-4">
                                                                <i className="fa fa-inbox fa-2x mb-2 d-block"></i>
                                                                No activity logs found for selected filters
                                                            </div>
                                                        }
                                                        striped
                                                        hover
                                                        condensed
                                                        wrapperClasses="table-responsive"
                                                        rowStyle={{ fontSize: '13px' }}
                                                    />

                                                    <Row className="mt-3 align-items-center">
                                                        <Col md={4} xs={6}>
                                                            <SizePerPageDropdownStandalone {...paginationProps} />
                                                        </Col>
                                                        <Col md={8} xs={6} className="text-right">
                                                            <PaginationListStandalone {...paginationProps} />
                                                        </Col>
                                                    </Row>
                                                </>
                                            )}
                                        </ToolkitProvider>
                                    )}
                                </PaginationProvider>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </div>
        );
    }
}
